let _settingService, _multiImageRequestsEnabled, _mediaDomains;

function ImageUrlService(restangular, settingsService) {
    _settingService = settingsService;
    const self = this;

    _settingService.getSettingValue('OneSite', 'MultiImageRequestsEnabled').then(function (setting) {
        _multiImageRequestsEnabled = setting;
    });

    _settingService.getSettingValue('OneSite', 'MediaDomainNames').then(function (settingMediaDomainNames) {
        _mediaDomains = settingMediaDomainNames;
        self.mediaDomains = _mediaDomains;
    });
}

ImageUrlService.prototype.hashCode = function (imgName) {
    let hash = 0;
    if (imgName.length === 0) {
        return hash;
    }

    for (let i = 0; i < imgName.length; i++) {
        const char = imgName.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
    }
    return hash;
};

ImageUrlService.prototype.getImageUrl = function (imgName, imgPath) {
    const self = this;
    if (_multiImageRequestsEnabled) {
        const mediaDomainLength = self.mediaDomains.length;
        if (mediaDomainLength === 0) {
            return imgPath + imgName;
        }

        return self.mediaDomains[(Math.abs(self.hashCode(imgName)) % mediaDomainLength)] + imgPath + imgName;
    }

    return imgPath + imgName;
};

ImageUrlService.prototype.invalidate = function () {
    this.mediaDomains = null;
};

module.exports = ImageUrlService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/images/image-url-service.js
 **/